import React from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/pro-regular-svg-icons';

export const IframeNavBarView = withRouter(({ isIframe = false, history }) => {
  const { t } = useTranslation();

  return isIframe ? (
    <div className="back-to-homepage row justify-content-start">
      <button type="button" className="link-button homepage-link-button" onClick={() => history.go(-1)}>
        <FontAwesomeIcon icon={faAngleLeft} />
        {t('back_to_video_page')}
      </button>
    </div>
  ) : null;
});

IframeNavBarView.propTypes = {
  isIframe: PropTypes.bool,
};
